import { DocumentListItem } from 'src/models/documentList';
import { DocumentListExtras } from 'src/models/documentList/extras';

export interface IdoPrintOption {
	displayvalue: string;
	documentId: number;
	idoId: number;
	instanceId: number;
	value: number;
}

export type IdoPrintListItem = {
	extras: {
		filename: string;
		printOptions: Array<IdoPrintOption>;
	} & DocumentListExtras;
} & DocumentListItem;

export const normalizeIdoPrintRow = (entry: unknown): IdoPrintListItem | null => {
	if (entry === null || typeof entry !== 'object') {
		return null;
	}

	const aggregateId = (entry as { aggregateId?: unknown }).aggregateId;

	if (typeof aggregateId !== 'string' || aggregateId === '') {
		return null;
	}

	const extras = (entry as { extras?: unknown }).extras;
	const printOptions =
		extras !== null && typeof extras === 'object' ? (extras as { printOptions?: unknown }).printOptions : undefined;

	if (!Array.isArray(printOptions)) {
		return null;
	}

	return entry as IdoPrintListItem;
};
